import { render, staticRenderFns } from "./szechenyi-card.vue?vue&type=template&id=4b49e1f4&scoped=true&lang=pug"
import script from "./szechenyi-card.vue?vue&type=script&lang=js"
export * from "./szechenyi-card.vue?vue&type=script&lang=js"
import style0 from "./szechenyi-card.vue?vue&type=style&index=0&id=4b49e1f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b49e1f4",
  null
  
)

export default component.exports